import { Box, IconButton, styled, Typography } from "@mui/material";
// import { UserCircle } from '@phosphor-icons/react';
import { fontSizes } from "../../../../layouts/fontSizes";

const StyledIconButton = styled(IconButton)({
  color: "inherit",
  marginLeft: "auto",
});

const StyledUserIcon = styled(Box)({
  color: "#7A5AF8",
  width: 26,
  height: 26,
});

const UserProfileContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  marginLeft: "auto",
  marginTop: "auto",
  marginBottom: "auto",
});

const UserProfileDetails = styled(Box)({
  textAlign: "right",
});

const UserProfileName = styled(Typography)({
  fontWeight: "bold",
  color: "#1A1A18",
  fontSize: "18px !important",
});

const UserProfileRole = styled(Typography)({
  color: "#1A1A18",
  fontSize: fontSizes.subtitle,
});

export {
  StyledIconButton,
  StyledUserIcon,
  UserProfileContainer,
  UserProfileDetails,
  UserProfileName,
  UserProfileRole,
};
